// Turn a raw tournament label from the schedule API — e.g. "Esports World Cup
// Bảng", "MSI Đấu Loại", "LCK Split 3" — into a short, clean league code for
// display. Matches on the league name regardless of the (localized) stage word,
// so it works on both already-stored values and future syncs.
const LEAGUE_PATTERNS: [RegExp, string][] = [
  [/esports world cup/i, "EWC"],
  [/first stand/i, "First Stand"],
  [/worlds/i, "Worlds"],
  [/\bmsi\b/i, "MSI"],
  [/kespa/i, "KeSPA Cup"],
  [/lck challengers/i, "LCK CL"],
  [/\blck\b/i, "LCK"],
  [/\blpl\b/i, "LPL"],
  [/\blec\b/i, "LEC"],
  [/\blcs\b/i, "LCS"],
  [/\blcp\b/i, "LCP"],
  [/\bcblol\b/i, "CBLOL"],
];

export function leagueLabel(raw?: string | null): string {
  if (!raw) return "";
  for (const [re, short] of LEAGUE_PATTERNS) {
    if (re.test(raw)) return short;
  }
  // Unknown league: fall back to the first word so it stays short.
  return raw.trim().split(/\s+/)[0];
}
